import json from "../json/subscriptionsRegionsList.json";

export default async () => JSON.parse(JSON.stringify(await json));
